import React from 'react';
import PropTypes from 'prop-types';
import TextareaAutosize from 'react-autosize-textarea';
import Geosuggest from '@ubilabs/react-geosuggest';
var field = function field(style, placeholder, value, handleInputChange, index) {
  if (style === 'geosuggest') {
    return /*#__PURE__*/React.createElement(Geosuggest, {
      initialValue: value,
      inputClassName: "form-control",
      placeholder: "e.g. Boston",
      types: ['(cities)'],
      onChange: function onChange(v) {
        return handleInputChange(v, index);
      },
      onSuggestSelect: function onSuggestSelect(obj) {
        return obj && handleInputChange(obj.label, index);
      }
    });
  }
  if (style === 'text_input') {
    return /*#__PURE__*/React.createElement("input", {
      type: "text",
      placeholder: placeholder,
      value: value,
      onChange: function onChange(e) {
        return handleInputChange(e.target.value, index);
      }
    });
  }
  return /*#__PURE__*/React.createElement(TextareaAutosize, {
    rows: 2,
    value: value,
    onChange: function onChange(e) {
      return handleInputChange(e.target.value, index);
    },
    placeholder: placeholder
  });
};
function Item(_ref) {
  var value = _ref.value,
    index = _ref.index,
    handleInputChange = _ref.handleInputChange,
    handleDeleteItem = _ref.handleDeleteItem,
    placeholder = _ref.placeholder,
    itemHeader = _ref.itemHeader,
    style = _ref.style;
  return /*#__PURE__*/React.createElement("div", {
    className: "item"
  }, style === 'list' && itemHeader && /*#__PURE__*/React.createElement("div", {
    className: "item-header"
  }, itemHeader, ' ', index + 1), /*#__PURE__*/React.createElement("div", {
    className: "item-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-grow"
  }, field(style, placeholder, value, handleInputChange, index)), /*#__PURE__*/React.createElement("div", {
    className: "delete-item"
  }, /*#__PURE__*/React.createElement("a", {
    role: "button",
    tabIndex: 0,
    type: "button",
    id: "delete-item",
    onClick: function onClick() {
      return handleDeleteItem(index);
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-trash-alt"
  })))));
}
Item.propTypes = {
  value: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  handleDeleteItem: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  itemHeader: PropTypes.string.isRequired,
  style: PropTypes.string.isRequired
};
export default Item;